/** Format enum for display: capitalize and replace _ with space (e.g. DAILY_UPDATE → Daily Update). */
export const formatEnumForDisplay = (value) => {
  if (value == null || value === "") return "";
  return String(value)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/** Issue log source type enum – use these values for API (sourceType / source_type). */
export const SOURCE_TYPE = {
  ALL: "",
  DAILY_UPDATE: "DAILY_UPDATE",
  INSPECTION: "INSPECTION",
  SITE_VISIT: "SITE_VISIT",
  CUSTOMER: "CUSTOMER",
  CONTRACTOR: "CONTRACTOR",
};

export const SOURCE_OPTIONS = [
  { value: SOURCE_TYPE.ALL, label: "All Sources" },
  { value: SOURCE_TYPE.DAILY_UPDATE, label: "Daily Update" },
  { value: SOURCE_TYPE.INSPECTION, label: "Inspection" },
  { value: SOURCE_TYPE.SITE_VISIT, label: "Site Visit" },
  { value: SOURCE_TYPE.CUSTOMER, label: "Customer" },
  { value: SOURCE_TYPE.CONTRACTOR, label: "Contractor" },
];

/** Display label for a source_type value (API returns enum; show as capitalized with spaces). */
export const getSourceTypeLabel = (value) => {
  if (value == null || value === "") return "-";
  return formatEnumForDisplay(value) || "-";
};

/** Status filter enum for API. */
export const ISSUE_STATUS = {
  OPEN: "OPEN",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  RESOLVED: "RESOLVED",
};

export const STATUS_OPTIONS = [
  { value: "", label: "All" },
  { value: ISSUE_STATUS.OPEN, label: "Open" },
  { value: ISSUE_STATUS.IN_PROGRESS, label: "In Progress" },
  { value: ISSUE_STATUS.DONE, label: "Done" },
  { value: ISSUE_STATUS.RESOLVED, label: "Resolved" },
];

/** Returns inline style object for status pill (portal Tailwind → inline RGBA styles). */
export const getStatusStyles = (status) => {
  const s = (status || "").toUpperCase().replace(/\s+/g, "_");
  if (s === "OPEN")
    return {
      backgroundColor: "rgba(239, 68, 68, 0.1)",
      color: "#dc2626",
      border: "1px solid rgba(239, 68, 68, 0.2)",
    };
  if (s === "IN_PROGRESS")
    return {
      backgroundColor: "rgba(249, 115, 22, 0.1)",
      color: "#ea580c",
      border: "1px solid rgba(249, 115, 22, 0.2)",
    };
  if (s === "DONE")
    return {
      backgroundColor: "#047857",
      color: "#fff",
      border: "1px solid #065f46",
    };
  if (s === "RESOLVED")
    return {
      backgroundColor: "rgba(34, 197, 94, 0.1)",
      color: "#16a34a",
      border: "1px solid rgba(34, 197, 94, 0.2)",
    };
  return {
    backgroundColor: "#f3f4f6",
    color: "#374151",
    border: "1px solid #e5e7eb",
  };
};

/** Severity enum for API. */
export const SEVERITY = {
  CRITICAL: "CRITICAL",
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
};

export const getPriorityStyles = (priority) => {
  const p = (priority || "").toUpperCase().replace(/\s+/g, "_");
  if (p === "CRITICAL")
    return { backgroundColor: "rgba(239, 68, 68, 0.1)", color: "#dc2626" };
  if (p === "HIGH")
    return { backgroundColor: "rgba(249, 115, 22, 0.1)", color: "#ea580c" };
  if (p === "MEDIUM")
    return { backgroundColor: "rgba(245, 158, 11, 0.1)", color: "#d97706" };
  if (p === "LOW")
    return { backgroundColor: "rgba(34, 197, 94, 0.1)", color: "#16a34a" };
  return { backgroundColor: "#f3f4f6", color: "#4b5563" };
};

/** Parse markup count from issue metadata (string or object). Returns number or null. */
export const getMarkupFromMetadata = (metadata) => {
  if (metadata == null) return null;
  try {
    const meta = typeof metadata === "string" ? JSON.parse(metadata) : metadata;
    if (meta && typeof meta.markup === "number") return meta.markup;
    return null;
  } catch {
    return null;
  }
};

export const DEFAULT_NO_IMAGE =
  "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b";
